var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ds-control mobile dsf_teas_student_myAskLeave" },
    [
      _c("div", { staticClass: "leave_header" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _vm.dataInfor.photo
              ? _c("van-image", {
                  staticClass: "head-img",
                  attrs: {
                    height: "60",
                    width: "60",
                    round: "",
                    src: _vm._f("imgFormat")(_vm.dataInfor.photo),
                  },
                })
              : _c("van-image", {
                  staticClass: "head-img",
                  attrs: {
                    height: "60",
                    width: "60",
                    round: "",
                    src: _vm._f("imgFormat")(_vm.defaultImg),
                  },
                }),
            _c("div", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.dataInfor.name)),
            ]),
            _c("div", { staticClass: "job" }, [
              _vm._v(_vm._s(_vm.dataInfor.dept)),
            ]),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "header-footer" },
          [
            _c(
              "van-dropdown-menu",
              { attrs: { "active-color": "#3C8DDB" } },
              [
                _c("van-dropdown-item", {
                  attrs: { options: _vm.yearactions },
                  on: { change: _vm.yearchange },
                  model: {
                    value: _vm.year.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.year, "value", $$v)
                    },
                    expression: "year.value",
                  },
                }),
                _c("van-dropdown-item", {
                  attrs: { options: _vm.typeactions },
                  on: { change: _vm.typechange },
                  model: {
                    value: _vm.type.value,
                    callback: function ($$v) {
                      _vm.$set(_vm.type, "value", $$v)
                    },
                    expression: "type.value",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "leave_content" },
        [
          _vm.dataInfor.monthData && _vm.dataInfor.monthData.length > 0
            ? _c("teasLeaveProcess", {
                attrs: { processList: _vm.dataInfor.monthData },
              })
            : _c("img", {
                staticClass: "nodata",
                attrs: {
                  src: require("_platform/assets/styles/themes/img/nodata2.png"),
                  alt: "",
                },
              }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }